import { useState } from "react";
import axios from "axios";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { constructPaymentData, constructBillingDetails } from "../../../utils/helpers/constructPaymentData";

const useStripeTransaction = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createAndProcessTransaction = async (paymentData) => {
    // console.log("line 13", paymentData);
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post("https://lbealjhg80.execute-api.us-east-1.amazonaws.com/dev2/transactions", paymentData);
      const { paymentIntent, subscription } = response.data;
      return { paymentIntent, subscription };
    } catch (err) {
      setError(err.message);
      console.error("Transaction Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const confirmCardPayment = async (clientSecret, billingDetails) => {
    if (!stripe || !elements) {
      setError("Stripe is not properly initialized");
      return null;
    }

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: billingDetails,
      },
    });

    if (result.error) {
      setError(result.error.message);
      return null;
    }

    return result.paymentIntent;
  };

  const processPayment = async (values, cartTotal, stripeCouponObj, discount, originalSubtotal, cartItems, customerId) => {
    const paymentData = constructPaymentData(values, cartTotal, stripeCouponObj, discount, originalSubtotal, cartItems, customerId);

    const transactionResponse = await createAndProcessTransaction(paymentData);

    if (!transactionResponse?.paymentIntent && !transactionResponse?.subscription) {
      return null;
    }

    let paymentResults = null;

    if (transactionResponse?.paymentIntent) {
      const billingDetails = constructBillingDetails(values);
      paymentResults = await confirmCardPayment(transactionResponse.paymentIntent.client_secret, billingDetails);
    }

    // Handle subscription separately if needed
    if (transactionResponse?.subscription) {
      // console.log("Subscription created:", transactionResponse.subscription);
    }

    return { paymentResults, subscription: transactionResponse.subscription };
  };

  return { processPayment, loading, error };
};

export default useStripeTransaction;
